<template><div><h1>纯 css close 图标</h1>
<div class="tip">
<p>关闭图标主要应用于弹窗(dialog)关闭按钮以及弹窗(popup)头部的关闭按钮。</p>
</div>
<h2>使用</h2>
<p>在你项目的<code>App.vue</code>引入，组件内不需要再重复引入。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">style</span> <span class="hljs-attr">lang</span>=<span class="hljs-string">"less"</span>&gt;</span><span class="undefined">
@import '~vux/src/styles/close.less';
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>
</code></pre>
<h2>类名</h2>
<ul>
<li><code>vux-close</code></li>
</ul>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"vux-close"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
</code></pre>
<p>可以参考 <code>XDialog</code> 演示。</p>
<h2>颜色</h2>
<p>当你想设置图标颜色时，直接设置 color 即可。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"vux-close"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"color:red;"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
</code></pre>
</div></template><script>
export default {
  head: {"title":"纯 css close 图标 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// close-281.vue?00a31fb6